import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';

export default class PriceList {
  constructor(priceList) {
    this.priceList = priceList;
    return this;
  }

  getDataForBusStop(busStopKey) {
    return this.priceList.FLYO_APP[busStopKey];
  }

  getDataForPostcode(postcode) {
    return this.priceList.TRF[postcode];
  }

  getAddressData(busStopName, postcode) {
    if (isEmpty(busStopName)) {
      //check price for postcode
      var data = this.getDataForPostcode(postcode);
    } else {
      //check by bus stop
      var data = this.getDataForBusStop(busStopName);
    }
    return data;
  }

  isAddressSupported(busStopName, postcode) {
    var data = this.getAddressData(busStopName, postcode);

    if (isEmpty(data)) {
      // the address is not supported
      return false;
    } else {
      return true;
    }
  }

  getTotalPrice(params) {
    var defaultParams = { busStopName: '', postcode: '', adults: 0, children: 0 };
    var params = merge(defaultParams, params);

    if (!this.priceList) {
      return null;
    }

    if (isEmpty(params.busStopName) && isEmpty(params.postcode)) {
      return null;
    }

    var data = this.getAddressData(params.busStopName, params.postcode);
    if (isEmpty(data)) {
      // the address is not supported
      return false;
    } else {
      return this.calculateTotalPrice(
        data,
        params.adults,
        params.children,
        params.seniors,
        params.students,
        params.teenagers
      );
    }
  }

  calculateTotalPrice(data, adultsParam, childrenParam, seniorsParams, studentsParams, teenagersParams) {
    var adultsNumber = this.convertToInt(adultsParam);
    var childrenNumber = this.convertToInt(childrenParam);
    var seniorsNumber = this.convertToInt(seniorsParams);
    var studentsNumber = this.convertToInt(studentsParams);
    var teenagersNumber = this.convertToInt(teenagersParams);
    var adultsSum = data.adults * adultsNumber;
    var childrenSum = data.kids * childrenNumber;
    var seniorsSum = data.seniors * seniorsNumber;
    var studentsSum = data.students * studentsNumber;
    var teenagersSum = data.teenagers * teenagersNumber;
    return adultsSum + childrenSum + seniorsSum + studentsSum + teenagersSum;
  }

  convertToInt(param) {
    var value = parseInt(param);
    if (isNaN(value)) {
      return 0;
    } else {
      return value;
    }
  }

}
